<template>
    <article class="product-cart">
        <div class="product-cart__images-ibg">
            <NuxtLink :to="`/product/${product.slug}`"><img :src="getImageProduct(product.downloads?.[0].path)" /></NuxtLink>
            <div class="product-cart__labels">
                <button class="product-cart__label _icon-close" @click="removeFromWishlist(product)"></button>
            </div>
        </div>
        <div class="product-cart__info">
            <h3 class="product-cart__title">
                <NuxtLink :to="`/product/${product.slug}`">{{ product.name }}</NuxtLink>
            </h3>
            <div class="product-cart__materials">
                <!-- <span>Перламутр,</span> -->
                <span>позолота 18к</span>
            </div>
        </div>
        <div class="product-cart__price price">
            <div class="price__current sale">{{ Math.round(product.price) }} грн.</div>
            <div class="price__old" v-if="product.old_price">{{ product.old_price }} грн.</div>
        </div>
        <NuxtLink :to="'/product/' + product.slug" class="product-cart__button button">Додати в кошик</NuxtLink>
    </article>
</template>

<script setup>
import { defineProps } from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
const globalStore = useGlobalStore();
const emit = defineEmits(["removedFromWishlist"]);

const getImageProduct = globalStore.getImageProduct;

const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
});

const router = useRouter();

const removeFromWishlist = (product) => {
    let wishlist = localStorage.getItem("wishlist");
    if (wishlist) {
        wishlist = JSON.parse(wishlist);
        wishlist = wishlist.filter((wishItem) => wishItem.id !== product.id);
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
        emit("removedFromWishlist");
    }
};
</script>

<style></style>
